module.exports = __webpack_public_path__ + "media/icons/gallery-next@2x-6eef3208.png";